export const getCurrentPageClass = () => {
    var currentPageClasses = document.querySelector('.page').classList.value.split(' ');
    for (var klass of currentPageClasses) {
        if (klass.indexOf('page-') > -1) {
            return klass.slice(5, klass.length);
        }
    }
    return 'unknown';
};

export default getCurrentPageClass;
